import { ScaffoldingSystemTypeData } from './scaffolding-system-type-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class SiteTonnage {
  SiteTonnageId: string;
  SiteId: string;
  ScaffoldingSystemId: string;
  TotalTonnage: string;
  OnHireErectedTonnage: number;
  AllocatedTonnage: number;
  ScaffoldingSystemData: ScaffoldingSystemTypeData;
}


